import React from "react";
import Heading from "../../components/Heading";
import Container from "../../components/Container";
import InstallationsTable from "./components/InstallationsTable";
import API from "../../services/API";

class ApkInstallations extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            installations: []
        }

        this.onRemove = this.onRemove.bind(this);
    }

    loadInstallations() {
        API.apkInstallations.get().then(response => {
            this.setState({ installations: response, isLoading: false })
        })
    }

    componentDidMount() {
        this.loadInstallations()
    }

    onRemove(deviceId) {
        if(!window.confirm(`Are you sure to delete: ${deviceId}?`)) return;

        this.setState({ isLoading: true })

        API.apkInstallations.delete(deviceId).then(() => this.loadInstallations())
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="APK Installations"/>

                <InstallationsTable installations={this.state.installations} onRemove={this.onRemove} />
            </Container>
        );
    }
}

export default ApkInstallations;


// WEBPACK FOOTER //
// ./src/scenes/ApkInstallations/index.js